<nav class="navbar navbar-expand-md navbar-dark bg-primary mb-4">
  <div class="container">
    <a routerLink="/" class="navbar-brand">Client Panel</a>
    <button class="navbar-toggler" type="button" data-target="collapse" data-target="#navbarMain">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarMain">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a routerLink="/" class="nav-link">Dashboard</a>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li *ngIf="!isLoggedIn && showRegister" class="nav-item">
          <a routerLink="/register" class="nav-link">Register</a>
        </li>
        <li *ngIf="!isLoggedIn && showRegister" class="nav-item">
          <a routerLink="/login" class="nav-link">Login</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a href="#" class="nav-link">{{ loggedInUser }}</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a href="/settings" class="nav-link">Settings</a>
        </li>
        <li *ngIf="isLoggedIn" class="nav-item">
          <a href="#" (click)="onLogoutClick()" class="nav-link">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
